export default __webpack_public_path__ + "static/ai-solutions-with-roadmap3--mobile-e11174fc4446aa8e71018fd87296787c.jpg";